export class SolicitudComponent {
	private id: string = null;
	private code_num: string = "";
	private code: string = ""; // Esto funcionaria como el numero de dossier
	private num_carte_etudiant: string = "";
	private num_carte_duplicata: string = "";
	private numero_carte_3: string = "";
	private num_order: string = "";
	private ville: number = null;
	private zone: number = null;
	private demande: number = null;
	private nom: string = "";
	private prenom: string = "";
	private province: number;
	private province_name: string = "";
	private commune: number;
	private commune_name: string = "";
	private adresse: string = "";
	private cin: string = "";
	private date_naissance: string = "";
	private tel: string = "";
	private email: string = "";
	private schoollevel: number = null;
	private schoollevel_name: string = "";
	private etablissement: number = null;
	private etablissement_name: string = "";
	private ligne1: string = "";
	private ligne2: string = "";
	private allLines: string = "";
	private carte_annee_prec: number = null;
	private numero_carte: string = "";
	private changer_ligne: number = null;
	private massarCode: string = "";

	// Datos de la cita
	private agence: string = "";
	private daterdv: string = "";
	private heure: string = "";

	private user_agent: string = "";
	private annule: number = null; // Falso int es un boolean 0 - 1
	private date_creation: string = "";
	private date_duplicata: string = "";
	private traitement: number = 0; // 0 - Masculino, 1 - Femenino
	private type_carte_id: number = null;

	constructor() { }

	public setId(id: string) { this.id = id; }
	public getId() { return this.id; }

	public setCode_num(code_num: string) { this.code_num = code_num; }
	public getCode_num() { return this.code_num; }

	public setCode(code: string) { this.code = code; }
	public getCode() { return this.code; }

	public setNum_carte_etudiant(num_carte_etudiant: string) { this.num_carte_etudiant = num_carte_etudiant; }
	public getNum_carte_etudiant() { return this.num_carte_etudiant; }

	public setNum_carte_duplicata(num_carte_duplicata: string) { this.num_carte_duplicata = num_carte_duplicata; }
	public getNum_carte_duplicata() { return this.num_carte_duplicata; }

	public setVille(ville: number) { this.ville = ville; }
	public getVille() { return this.ville; }

	public setZone(zone: number) { this.zone = zone; }
	public getZone() { return this.zone; }

	public setDemande(demande: number) { this.demande = demande; }
	public getDemande() { return this.demande; }

	public setProvince(province: number) { this.province = province; }
	public getProvince() { return this.province; }

	public setProvince_name(province_name: string) { this.province_name = province_name; }
	public getProvince_name() { return this.province_name; }

	public setCommune(commune: number) { this.commune = commune; }
	public getCommune() { return this.commune; }

	public setCommune_name(commune_name: string) { this.commune_name = commune_name; }
	public getCommune_name() { return this.commune_name; }

	public setSchoollevel(schoollevel: number) { this.schoollevel = schoollevel; }
	public getSchoollevel() { return this.schoollevel; }

	public setSchoollevel_name(schoollevel_name: string) { this.schoollevel_name = schoollevel_name; }
	public getSchoollevel_name() { return this.schoollevel_name; }

	public setEtablissement(etablissement: number) { this.etablissement = etablissement; }
	public getEtablissement() { return this.etablissement; }

	public setEtablissement_name(etablissement_name: string) { this.etablissement_name = etablissement_name; }
	public getEtablissement_name() { return this.etablissement_name; }

	public setCarte_annee_prec(carte_annee_prec: number) { this.carte_annee_prec = carte_annee_prec; }
	public getCarte_annee_prec() { return this.carte_annee_prec; }

	public setAnnule(annule: number) { this.annule = annule; }
	public getAnnule() { return this.annule; }

	public setTraitement(traitement: number) { this.traitement = traitement; }
	public getTraitement() { return this.traitement; }

	public setType_carte_id(type_carte_id: number) { this.type_carte_id = type_carte_id; }
	public getType_carte_id() { return this.type_carte_id; }

	public setNumero_carte_3(numero_carte_3: string) { this.numero_carte_3 = numero_carte_3; }
	public getNumero_carte_3() { return this.numero_carte_3; }

	public setNum_order(num_order: string) { this.num_order = num_order; }
	public getNum_order() { return this.num_order; }

	public setNom(nom: string) { this.nom = nom; }
	public getNom() { return this.nom; }

	public setPrenom(prenom: string) { this.prenom = prenom; }
	public getPrenom() { return this.prenom; }

	public setAdresse(adresse: string) { this.adresse = adresse; }
	public getAdresse() { return this.adresse; }

	public setCin(cin: string) { this.cin = cin; }
	public getCin() { return this.cin; }

	public setDate_naissance(date_naissance: string) { this.date_naissance = date_naissance; }
	public getDate_naissance() { return this.date_naissance; }

	public setTel(tel: string) { this.tel = tel; }
	public getTel() { return this.tel; }

	public setEmail(email: string) { this.email = email; }
	public getEmail() { return this.email; }

	public setLigne1(ligne1: string) { this.ligne1 = ligne1; }
	public getLigne1() { return this.ligne1; }

	public setLigne2(ligne2: string) { this.ligne2 = ligne2; }
	public getLigne2() { return this.ligne2; }

	public setNumero_carte(numero_carte: string) { this.numero_carte = numero_carte; }
	public getNumero_carte() { return this.numero_carte; }

	public setChanger_ligne(changer_ligne: number) { this.changer_ligne = changer_ligne; }
	public getChanger_ligne() { return this.changer_ligne; }

	public setAgence(agence: string) { this.agence = agence; }
	public getAgence() { return this.agence; }

	public setDaterdv(daterdv: string) { this.daterdv = daterdv; }
	public getDaterdv() { return this.daterdv; }

	public setHeure(heure: string) { this.heure = heure; }
	public getHeure() { return this.heure; }

	public setUser_agent(user_agent: string) { this.user_agent = user_agent; }
	public getUser_agent() { return this.user_agent; }

	public setDate_creation(date_creation: string) { this.date_creation = date_creation; }
	public getDate_creation() { return this.date_creation; }

	public setDate_duplicata(date_duplicata: string) { this.date_duplicata = date_duplicata; }
	public getDate_duplicata() { return this.date_duplicata; }

	public setAllLines(allLines: string) { this.allLines = allLines; }
	public getAllLines() { return this.allLines; }

	public setMassarCode(massarCode: string) { this.massarCode = massarCode; }
	public getMassarCode() { return this.massarCode; }

	public fixAllLines() {
		this.getLigne1()
		this.getLigne2()
		var finalString = this.getLigne1();
		if (typeof finalString != "undefined" && finalString != "" && this.getLigne2() != "" && typeof this.getLigne2() != "undefined") {
			finalString += ":" + this.getLigne2();
		} else if (typeof finalString == "undefined" || finalString == "") {
			finalString = this.getLigne2();
		}
		this.setAllLines(finalString);
	}

	public getLineFromIndex(index: number) {
		var linesConSeparador = this.getAllLines();
		if (typeof linesConSeparador == "undefined") {
			return null;
		} else {
			return linesConSeparador.split(":")[index];
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/DTOs/Solicitud.component.ts